import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  TextField,
  useTheme,
  Grid,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Modal,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET, POST } from "../Generic/CrudRequest";
import ModalGeneric from "../Generic/ModalGeneric";
import moment from "moment";
import { useLocation } from "react-router-dom";
import DetailsUnit from "./DetailsUnit";
import DetailsLoad from "./DetailsLoad";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EncryptionUtils from "../../Utils/EncryptionUtils";
import Alerts from "../../Utils/Alerts";
import { useTranslation } from "react-i18next";

export default function DetailsInspection(props) {
  const theme = useTheme();
  const { config } = props;
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [inspectionData, setInspectionData] = useState();
  const [startIndex, setStartIndex] = useState(0);
  const [expanded, setExpanded] = useState(true);
  const [
    tiposClasificacionImagenInspecciones,
    setClasificacionImagenTiposInspecciones,
  ] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [bodyModal, setBodyModal] = useState(null);
  const [imageURL, setImageURL] = useState("");
  const [imageArray, setImageArray] = useState([]);
  const [imageSend, setImageSend] = useState("");
  const [fileName, setFileName] = useState("");
  const [caseModal, setCaseModal] = useState(0);
  const [idClasificacionImagen, setIdClasificacionImagen] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const columns = [
  { id: "puntoInspeccion", label: t("inspections.details.inspectionPoints.title"), minWidth: "100px" },
  { id: "valor", label: t("inspections.details.inspectionPoints.value"), minWidth: "100px" },
];

  useEffect(() => {
    if (location.pathname.includes("/Inspecciones/Detalle")) {
      const locationId = getLocationIdFromPath(location.pathname);
      getdataInspectionById(locationId);
    }
  }, [location.pathname]);

  // Escuchar cambios de idioma y recargar la página
  useEffect(() => {
    const handleLanguageChange = () => {
      // Recargar la página cuando cambie el idioma
      window.location.reload();
    };

    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  useEffect(() => {
    if (imageSend !== "" && fileName !== "") {
      setIsModalOpen(true);
      setCaseModal(1);
      //setIdClasificacionImagen(idClasificacionImagen);
      setModalTitle(t("inspections.details.modalTitleAddImage"));
      setModalDescription("");
      setBodyModal(
        <Grid item xs={12} marginTop={2}>
          <div
            //onDrop={handleFileDrop}
            //onDragOver={handleDragOver}
            style={{
              textAlign: "center",
              padding: "3px",
              border: "2px dashed #aaa",
              borderRadius: "4px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
            <input
              type="file"
              id="file_Documento"
              accept="image/*"
              onChange={handleFileUpload}
              style={{ display: "none" }}
              //ref={fileInputRef}
            />
            {imageSend !== "" ? (
              <>
                <img
                  src={imageURL}
                  alt={t("inspections.details.messages.loadedImage")}
                  style={{
                    width: "50%",
                    height: "50%",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelectedImage(imageURL);
                    setOpenModal(true);
                  }}
                />
                <Typography>{fileName}</Typography>
              </>
            ) : (
              <label htmlFor="file_Documento">
                <div>
                  <Icons
                    fontSize="large"
                    iconName="Image"
                    style={{
                      marginBottom: "1px",
                      color: theme.palette.primary.main,
                    }}
                  />
                  <Typography>{t("inspections.details.clickToUpload")}</Typography>
                </div>
              </label>
            )}
          </div>
        </Grid>
      );
    }
  }, [imageSend, fileName, idClasificacionImagen]);

  useEffect(() => {
    if (!isModalOpen) {
      setImageSend("");
      setFileName("");
      setCaseModal(0);
      setImageArray([]);
    }
  }, [isModalOpen]);

  const getLocationIdFromPath = (pathname) => {
    const parts = pathname.split("/");
    return parts[parts.length - 1];
  };

  const getdataInspectionById = async (inspectionId) => {
    const dataInspection = await GET(
      `${config.url}/api/GeneralInspections/GetInspeccionGeneralById/${inspectionId}`
    );

    setInspectionData(dataInspection);

    const currentInspectionIndex =
      dataInspection?.inspeccionGeneralRelacionadas?.findIndex(
        (inspeccion) =>
          inspeccion.idInspeccionGeneral === parseInt(inspectionId)
      ) ?? 0;

    const startIndexToCenter = Math.max(0, currentInspectionIndex - 1);
    setStartIndex(startIndexToCenter);

    fetchClasificacionImagenTiposInspeccion(
      dataInspection?.inspectionGeneral.idInspeccionGeneralTipo
    );
  };

  const fetchClasificacionImagenTiposInspeccion = async (idTipoInspeccion) => {
    const clasificacionImagenTipoInspeccion = await GET(
      `${config.url}/api/ClasificacionImagenInspeccion/ClasificacionImagenByTipoInspeccion`,
      {
        idTipoInspeccion: idTipoInspeccion,
      }
    );

    setClasificacionImagenTiposInspecciones(clasificacionImagenTipoInspeccion);
  };

  const saveImageInspection = async () => {
    await POST(
      `${config.url}/api/GeneralInspectionImages/Agregar-Imagen`,
      imageArray
    );

    window.location.reload();
  };

  const handleNext = () => {
    if (
      startIndex <
      inspectionData?.inspeccionGeneralRelacionadas?.length - 1
    ) {
      setStartIndex(startIndex + 1);
    }
  };

  const handleBefore = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const handleAccordionChange = () => {
    setExpanded(!expanded);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setIsModalOpen(false);
  };

  const handleAcceptModal = () => {
    if (caseModal === 1) {
      saveImageInspection();
      setIsModalOpen(false);
    } else {
    }
    setOpenModal(false);
    setIsModalOpen(false);
  };

  const handleOpenModalImagesInspeccion = () => {
    setIsModalOpen(true);
    setModalTitle(t("inspections.details.gallery.title"));
    setModalDescription("");
    setBodyModal(
      <Grid container spacing={2} marginTop={1}>
        {inspectionData.inspectionGeneral.inspeccionGeneralImagenes.length > 0 ? (
          inspectionData.inspectionGeneral.inspeccionGeneralImagenes.map(
            (value, index) => (
              <Grid item xs={2} key={index}>
                <img
                  src={`${config.url}/${config.paths.inspectionGeneralImage}/${value.nombreArchivo}`}
                  alt={t("inspections.details.messages.noImage", { index: index + 1 })}
                  style={{
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelectedImage(
                      `${config.url}/${config.paths.inspectionGeneralImage}/${value.nombreArchivo}`
                    );
                    setOpenModal(true);
                  }}
                />
              </Grid>
            )
          )
        ) : (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Icons iconName="ImageNotSupported" fontSize="large" />
            <Typography>{t("inspections.details.gallery.noImagesFound")}</Typography>
          </Grid>
        )}
      </Grid>
    );
  };

  const handleFileUpload = (e, id) => {
    const file = e.target.files[0];
    handleFile(file, id);
  };

  const handleFile = (file, id) => {
    const reader = new FileReader();

    if (!file.type.startsWith("image/")) {
      handleShowAlert("inspections.details.messages.onlyImagesAllowed", "warning");
      return;
    }

    reader.onload = async (event) => {
      const binaryString = event.target.result;
      const base64String = reader.result.split(",")[1];
      setImageSend(base64String);
      setImageURL(binaryString);
      setFileName(file.name);

      const dataUser = EncryptionUtils.getDecryptedData("user");
      const parsedUser = JSON.parse(dataUser);

      const newGeneralInspectionImage = {
        idInspeccionGeneralImagen: 0,
        idInspeccionGeneral:
          inspectionData?.inspectionGeneral.idInspeccionGeneral,
        idClasificacionImagenInspeccion: id,
        nombreArchivo: "",
        base64: base64String,
        origen: "",
        usuarioRegistro: parsedUser.userId,
        fechaRegistro: null,
        estatus: true,
      };

      setImageArray((prevArray) => [...prevArray, newGeneralInspectionImage]);
    };

    reader.readAsDataURL(file);
  };

  const handleAddImage = (idClasificacionImagenInspeccion) => {
    setIsModalOpen(true);
    setCaseModal(1);
    setImageArray([]);
    //setIdClasificacionImagen(idClasificacionImagenInspeccion);
    setModalTitle(t("inspections.details.modalTitleAddImage"));
    setModalDescription("");
    setBodyModal(
      <Grid item xs={12} marginTop={2}>
        <div
          //onDrop={handleFileDrop}
          //onDragOver={handleDragOver}
          style={{
            textAlign: "center",
            padding: "3px",
            border: "2px dashed #aaa",
            borderRadius: "4px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
          }}
        >
          <input
            type="file"
            id="file_Documento"
            accept="image/*"
            onChange={(e) =>
              handleFileUpload(e, idClasificacionImagenInspeccion)
            }
            style={{ display: "none" }}
            //ref={fileInputRef}
          />
          {imageSend !== "" ? (
            <img
              src={imageURL}
              alt={t("inspections.details.messages.loadedImage")}
              style={{
                width: "50%",
                height: "50%",
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedImage(imageURL);
                setOpenModal(true);
              }}
            />
          ) : (
            <label htmlFor="file_Documento">
              <div>
                <Icons
                  fontSize="large"
                  iconName="Image"
                  style={{
                    marginBottom: "1px",
                    color: theme.palette.primary.main,
                  }}
                />
                <Typography> {t("inspections.details.clickToUpload")}</Typography>
              </div>
            </label>
          )}
        </div>
      </Grid>
    );
  };

  const handleOpenModalGaleriCheckList = (idInspeccionPuntoInspeccion) => {
    setIsModalOpen(true);
    setModalTitle(t("inspections.details.gallery.title"));
    setModalDescription("");
    setBodyModal(
      <Grid container spacing={2} marginTop={1}>
        {inspectionData.inspectionGeneral.puntosInspeccion
          .filter(
            (filter) =>
              filter.idInspeccionPuntoInspeccion === idInspeccionPuntoInspeccion
          )
          .map((value, index) => (
            <React.Fragment key={index}>
              {value.fotos.length > 0 ? (
                value.fotos.map((valueDamage, indexDamage) => (
                  <Grid item xs={2} key={indexDamage}>
                    <img
                      src={`${config.url}/${config.paths.inspectionPointCheckList}/${valueDamage}`}
                       alt={t("inspections.details.messages.noImage", { index: indexDamage + 1 })}
                      style={{
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setSelectedImage(
                          `${config.url}/${config.paths.inspectionPointCheckList}/${valueDamage}`
                        );
                        setOpenModal(true);
                      }}
                    />
                  </Grid>
                ))
              ) : (
                <Grid item xs={12} key={index} style={{ textAlign: "center" }}>
                  <Icons iconName="ImageNotSupported" fontSize="large" />
                  <Typography>
                    {t("inspections.details.gallery.noImagesForInspection")}
                  </Typography>
                </Grid>
              )}
            </React.Fragment>
          ))}
        {inspectionData.inspectionGeneral.puntosInspeccion.length === 0 && (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Icons iconName="ImageNotSupported" fontSize="large" />
            <Typography>{t("inspections.details.gallery.noImagesFound")}</Typography>
          </Grid>
        )}
      </Grid>
    );
  };

  const handleShowAlert = (message, type) => {
    setAlertMessage(t(message));
    setAlertType(type);
    setShowAlert(true);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <>
      {showAlert && (
        <Alerts
          error={alertMessage}
          type={alertType}
          onClose={handleCloseAlert}
        />
      )}
      <Card
        variant="outlined"
        sx={{
          overflow: "hidden",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: 2,
        }}
      >
        {
          <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <img
                src={selectedImage}
                alt={t("inspections.details.messages.selectedImage")}
                style={{ maxWidth: "100%", maxHeight: "100vh" }}
              />
            </Box>
          </Modal>
        }
        {isModalOpen && (
          <ModalGeneric
            open={isModalOpen}
            title={modalTitle}
            description={modalDescription}
            onClose={handleCloseModal}
            onAccept={handleAcceptModal}
            bodyComponent={bodyModal}
          />
        )}
        <CardContent>
          <CardContent
            sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
          >
            <Icons
              iconName="ArrowBack"
              fontSize="large"
              style={{
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
                marginRight: 20,
              }}
              to="/Inspecciones"
              tooltip={t("buttons.back")}
            />
            <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
              {t("inspections.details.title")}
            </Typography>
          </CardContent>
          <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
          <Card
            variant="outlined"
            sx={{
              overflow: "hidden",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: 2,
              maxWidth: "calc(100% - 32px)",
              margin: "auto",
              marginTop: 2,
            }}
          >
            <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
              <Typography
                variant="h5"
                sx={{
                  flex: "1",
                  color: theme.palette.primary.main,
                }}
              >
                {t("inspections.details.history")}
              </Typography>
              <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
              <Card sx={{ marginTop: 2 }}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid
                    item
                    xs={1}
                    container
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Icons
                      iconName="NavigateBefore"
                      fontSize="large"
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        color: "#fff",
                      }}
                      onClick={handleBefore}
                      tooltip={t("inspections.details.buttons.previous")}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    container
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid container spacing={1}>
                      {inspectionData?.inspeccionGeneralRelacionadas
                        ?.slice(startIndex, startIndex + 3)
                        .map((inspection, index) => (
                          <Grid item key={index} xs={4}>
                            <Link
                              to={`/Inspecciones/Detalle/${inspection.idInspeccionGeneral}`}
                              style={{ textDecoration: "none" }}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  minWidth: "270px",
                                  maxHeight: "100px",
                                  margin: 1,
                                  backgroundColor:
                                    inspection.idInspeccionGeneral ===
                                    inspectionData.inspectionGeneral
                                      .idInspeccionGeneral
                                      ? theme.palette.primary.main
                                      : theme.palette.white.main,
                                  color:
                                    inspection.idInspeccionGeneral ===
                                    inspectionData.inspectionGeneral
                                      .idInspeccionGeneral
                                      ? theme.palette.white.main
                                      : theme.palette.primary.main,
                                  "&:hover": {
                                    backgroundColor: theme.palette.primary.main,
                                    color: "#FFFFFF",
                                  },
                                }}
                              >
                                {t("inspections.title")} {inspection.inspeccionGeneralTipo}
                                <br />
                                No. {inspection.idInspeccionGeneral}
                                <br />
                                {moment
                                  .utc(inspection.fechaInicio)
                                  .local()
                                  .format("MM/DD/YYYY HH:mm A")}
                              </Button>
                            </Link>
                          </Grid>
                        ))}
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    container
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Icons
                      iconName="NavigateNext"
                      fontSize="large"
                      style={{
                        backgroundColor: theme.palette.primary.main,
                        color: "#fff",
                      }}
                      onClick={handleNext}
                      tooltip={t("inspections.details.buttons.next")}
                    />
                  </Grid>
                </Grid>
              </Card>
            </CardContent>
          </Card>
          <Card
            variant="outlined"
            sx={{
              overflow: "hidden",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: 2,
              maxWidth: "calc(100% - 32px)",
              margin: "auto",
              marginTop: 2,
            }}
          >
            <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
              <CardContent
                sx={{
                  display: "flex",
                  alignItems: "center",
                  margin: -2,
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    flex: "1",
                    color: theme.palette.primary.main,
                  }}
                >
                  {t("inspections.details.generalInfo")}
                </Typography>
                <Icons
                  iconName="Collections"
                  fontSize="large"
                  style={{
                    marginLeft: "auto",
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.white.main,
                  }}
                  onClick={handleOpenModalImagesInspeccion}
                  tooltip={t("inspections.details.buttons.gallery")}
                />
              </CardContent>
              <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
              <Grid container spacing={2} sx={{ marginTop: 2 }}>
                <Grid item xs={12} md={3}>
                  <TextField
                    label={t("inspections.details.inspectionStartDate")}
                    name="fechaInicial"
                    variant="standard"
                    fullWidth
                    value={
                      inspectionData?.inspectionGeneral?.fechaInicio
                        ? moment
                            .utc(inspectionData?.inspectionGeneral.fechaInicio)
                            .local()
                            .format("MM/DD/YYYY HH:mm A")
                        : t("inspections.details..messages.notAvailable")
                    }
                    InputProps={{ disableUnderline: true }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label={t("inspections.details.inspectionEndDate")}
                    name="fechaFinal"
                    variant="standard"
                    fullWidth
                    value={
                      inspectionData?.inspectionGeneral?.fechaFinal
                        ? moment
                            .utc(inspectionData?.inspectionGeneral.fechaFin)
                            .local()
                            .format("MM/DD/YYYY HH:mm A")
                        : t("inspections.details.messages.notAvailable")
                    }
                    InputProps={{ disableUnderline: true }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label={t("inspections.details.load")}
                    name="noCarga"
                    variant="standard"
                    fullWidth
                    value={
                      inspectionData?.inspectionGeneral?.noCarga
                        ? inspectionData.inspectionGeneral.noCarga
                        : t("inspections.details.messages.notAvailable")
                    }
                    InputProps={{ disableUnderline: true }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label={t("inspections.details.inspectionType")}
                    name="inspeccionGeneralTipo"
                    variant="standard"
                    fullWidth
                    value={
                      inspectionData?.inspectionGeneral?.inspeccionGeneralTipo
                        ? inspectionData.inspectionGeneral.inspeccionGeneralTipo
                        : t("inspections.details.messages.notAvailable")
                    }
                    InputProps={{ disableUnderline: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          {inspectionData?.inspectionGeneral?.idInspeccionGeneralTipo === 2 && (
            <DetailsUnit
              props={props}
              inspectionData={inspectionData}
              config={config}
            />
          )}
          {inspectionData?.inspectionGeneral?.idInspeccionGeneralTipo === 1 && (
            <DetailsLoad props={props} inspectionData={inspectionData} />
          )}
          <CardContent sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }}>
            <Accordion
              expanded={expanded}
              onChange={handleAccordionChange}
              sx={{
                overflow: "hidden",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                border: "1px solid rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
                maxWidth: "100%",
                margin: "auto",
              }}
            >
              <AccordionSummary
                sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: theme.palette.primary.main,
                  }}
                >
                  {t("inspections.details.checkListPoints")}
                </Typography>
              </AccordionSummary>
              <Divider sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }} />
              <AccordionDetails
                sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}
              >
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align="left"
                            style={{
                              minWidth: column.minWidth,
                              fontWeight: "bold",
                            }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {inspectionData?.inspectionGeneral?.puntosInspeccion
                        .length === 0 && (
                        <TableRow>
                          <TableCell
                            colSpan={columns.length + 1}
                            align="center"
                          >
                            {t("inspections.details.noDamages")}
                          </TableCell>
                        </TableRow>
                      )}
                      {inspectionData?.inspectionGeneral?.puntosInspeccion.map(
                        (row, index) => {
                          return (
                            <TableRow key={index}>
                              {columns.map((column) => (
                                <TableCell key={column.id} align="left">
                                  {row[column.id] !== null &&
                                  row[column.id] !== "" ? (
                                    row[column.id] === "true" ? (
                                      t("inspections.details.true")
                                    ) : row[column.id] === "false" ? (
                                      t("inspections.details.false")
                                    ) : (
                                      row[column.id]
                                    )
                                  ) : (
                                    <i>{t("inspections.details.messages.notAvailable")}</i>
                                  )}
                                </TableCell>
                              ))}
                              <TableCell>
                                <Icons
                                  iconName="Collections"
                                  fontSize="medium"
                                  style={{
                                    backgroundColor: theme.palette.primary.main,
                                    color: "#fff",
                                  }}
                                  onClick={() =>
                                    handleOpenModalGaleriCheckList(
                                      row.idInspeccionPuntoInspeccion
                                    )
                                  }
                                  tooltip={t("inspections.details.buttons.gallery")}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          </CardContent>
          <Card
            variant="outlined"
            sx={{
              overflow: "hidden",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: 2,
              maxWidth: "calc(100% - 32px)",
              margin: "auto",
              marginTop: 2,
            }}
          >
            <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
              <Typography
                variant="h5"
                sx={{
                  flex: "1",
                  color: theme.palette.primary.main,
                }}
              >
                {t("inspections.details.inspectionImages")}
              </Typography>
              <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
            </CardContent>
            <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
              {tiposClasificacionImagenInspecciones.map((tipo, index) => (
                <Accordion
                  sx={{
                    overflow: "hidden",
                    maxWidth: "100%",
                    margin: "auto",
                  }}
                  key={index}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-${index}-content`}
                    id={`panel-${index}-header`}
                  >
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: theme.palette.primary.main,
                      }}
                    >
                      {tipo.descripcion}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Icons
                      iconName="AddPhotoAlternate"
                      fontSize="medium"
                      style={{
                        alignSelf: "flex-end",
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.white.main,
                      }}
                      onClick={() =>
                        handleAddImage(tipo.idClasificacionImagenInspeccion)
                      }
                      tooltip={t("inspections.details.buttons.add")}
                    />
                    <Grid container spacing={2} marginTop={1}>
                      {inspectionData.inspectionGeneral.inspeccionGeneralImagenes
                        .filter(
                          (imagen) =>
                            imagen.idClasificacionImagenInspeccion ===
                            tipo.idClasificacionImagenInspeccion
                        )
                        .map((value, index) => (
                          <Grid item xs={2} key={index}>
                            <img
                              src={`${config.url}/${config.paths.inspectionGeneralImage}/${value.nombreArchivo}`}
                              alt={t("inspections.details.messages.noImage", { index: index + 1 })}
                              style={{
                                width: "100%",
                                height: "100%",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setSelectedImage(
                                  `${config.url}/${config.paths.inspectionGeneralImage}/${value.nombreArchivo}`
                                );
                                setOpenModal(true);
                              }}
                            />
                          </Grid>
                        ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ))}
            </CardContent>
          </Card>
        </CardContent>
      </Card>
    </>
  );
}
